import React, { useState, useEffect } from 'react';
import { X, Info } from 'lucide-react';

const InfoBar = () => {
  const [messages, setMessages] = useState([]);
  const [isVisible, setIsVisible] = useState(true);
  const [countdown, setCountdown] = useState(3);
  const [isFading, setIsFading] = useState(false);

  // No automatic status checking on page load
  // const checkSystemStatus = async () => {
  //   // Status checking removed - no automatic messages on page load
  // };

  // Auto-dismiss messages after 3 seconds with countdown and fade-out
  useEffect(() => {
    if (messages.length > 0) {
      setCountdown(3);
      setIsFading(false);
      
      const countdownTimer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            // Start fade-out effect
            setIsFading(true);
            // Remove messages after fade-out animation
            setTimeout(() => {
              setMessages([]);
              setIsFading(false);
            }, 300);
            return 3;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(countdownTimer);
    }
  }, [messages]);

  const dismissMessage = (messageId) => {
    setMessages(prev => prev.filter(msg => msg.id !== messageId));
  };

  const getIcon = () => {
    return <Info size={16} className="text-info" />;
  };

  const getBackgroundClass = () => {
    return 'bg-info-subtle border-info';
  };

  const getTextClass = () => {
    return 'text-info';
  };

  if (!isVisible || messages.length === 0) {
    return null;
  }

  return (
    <div className="info-bar" style={{ zIndex: 1001 }}>
      {messages.map((message) => (
        <div
          key={message.id}
          className={`alert ${getBackgroundClass()} border-start border-4 mb-0 py-2 px-3 d-flex align-items-center justify-content-between ${isFading ? 'fade-out' : ''}`}
          role="alert"
          style={{
            opacity: isFading ? 0 : 1,
            transform: isFading ? 'translateY(-10px)' : 'translateY(0)'
          }}
        >
          <div className="d-flex align-items-center gap-2">
            {getIcon()}
            <span className={`small ${getTextClass()}`}>
              {message.text}
            </span>
          </div>
          
          <div className="d-flex align-items-center gap-2">
            {/* Countdown indicator */}
            <div className="d-flex align-items-center gap-1">
              <small className="text-muted">Auto-hide in</small>
              <span className="badge bg-secondary">{countdown}s</span>
            </div>
            
            {/* Manual dismiss button */}
            {message.dismissible && (
              <button
                type="button"
                className="btn-close btn-close-sm"
                onClick={() => dismissMessage(message.id)}
                aria-label="Close"
              >
                <X size={14} />
              </button>
            )}
          </div>
        </div>
      ))}
      
      <style jsx>{`
        .info-bar {
          position: sticky;
          top: 0;
          background: white;
          border-bottom: 1px solid #dee2e6;
        }
        
        .info-bar .alert {
          border-radius: 0;
          margin: 0;
          transition: opacity 0.3s ease, transform 0.3s ease;
        }
        
        .info-bar .alert:last-child {
          border-bottom: none;
        }
        
        .btn-close {
          padding: 0.25rem;
          background-size: 0.75em;
        }
        
        .btn-close:hover {
          opacity: 0.75;
        }
        
        .badge {
          font-size: 0.75rem;
          padding: 0.25rem 0.5rem;
        }
        
        .countdown-container {
          transition: all 0.2s ease;
        }
      `}</style>
    </div>
  );
};

export default InfoBar;
